import { floatButtonStyle, imageExperienceContentStyle, editImageCommonStyle, extensionEditorStyles } from '@bingads-webui-campaign-react/common-styles';

const pmaxImageExperienceContentStyle = (palette = {}, iconFontFamily = 'MsAds MDL2 Assets') => ({
  '& .image-experience-content': {
    marginBottom: 10,
    minWidth: 669,

    '& .image-list-view-content .image-list': {
      position: 'relative',
      marginBottom: 0,

      '& .image-list-content': {
        width: '100%',
        overflowX: 'auto',

        '&:after': {
          content: '""',
          display: 'inline-flex',
          flexBasis: 28,
          flexShrink: 0,
        },

        '& .ms-ChoiceField-wrapper': {
          padding: 1.5,
          '&:after': {
            inset: 0,
          },
        },

        '& .image-list-item .image-list-item-image, & .image-list-item .image-list-item-video': {
          '&:hover': {
            '& .glyphicon.glyphicon-remove.image-delete': {
              opacity: 0.75,

              '&:hover': {
                opacity: 1,
              },
            },

            '& .glyphicon.glyphicon-pencil.image-edit': {
              opacity: 0.75,

              '&:hover': {
                opacity: 1,
              },
            },
          },

          '& .glyphicon.glyphicon-remove.image-delete': {
            extend: floatButtonStyle({ palette }).floatButton,
            fontFamily: iconFontFamily,
            lineHeight: 1,
            fontSize: 16,
            margin: 0,
            padding: 8,
            position: 'absolute',
            left: 'auto',
            top: 'auto',
            right: 2,
            bottom: 2,
            borderRadius: '50%',
            marginBottom: 8,
            marginRight: 20,
            opacity: 0,

            '&:before': {
              content: '"\\E711"',
            },

            '&:hover, &:focus': {
              opacity: 1,
            },
          },

          '& .glyphicon.glyphicon-pencil.image-edit': {
            extend: floatButtonStyle({ palette }).floatButton,
            fontFamily: iconFontFamily,
            lineHeight: 1,
            fontSize: 16,
            border: 'none',
            position: 'absolute',
            left: 2,
            top: 'auto',
            right: 'auto',
            bottom: 2,
            borderRadius: '50%',
            marginLeft: 20,
            marginBottom: 8,
            height: 32,
            width: 32,
            padding: 0,
            opacity: 0,

            '&:before': {
              content: '"\\E70F"',
            },

            '&:hover, &:focus': {
              opacity: 1,
            },
          },

          '& .glyphicon.glyphicon-plus.image-add': {
            extend: floatButtonStyle({ palette }).floatButton,
            fontFamily: iconFontFamily,
            lineHeight: 1,
            fontSize: 16,
            border: 'none',
            position: 'absolute',
            height: 24,
            width: 32,
            left: 2,
            top: 'auto',
            right: 'auto',
            bottom: 2,
            background: 'transparent',
            marginLeft: 40,
            marginBottom: 32,
            padding: 0,
            opacity: 0.75,

            '&:before': {
              content: '"\\E710"',
              marginRight: 4,
              marginLeft: 4,
            },

            '&:hover': {
              opacity: 1,
              background: 'transparent',
            },
          },

          '& .glyphicon.glyphicon-pencil.image-edit.is-recommended-image': {
            opacity: 0.5,
          },

          '& .image-edit + .glyphicon.glyphicon-remove.image-delete': {
            extend: floatButtonStyle({ palette }).floatButton,
            fontFamily: iconFontFamily,
            lineHeight: 1,
            fontSize: 16,
            border: 'none',
            position: 'absolute',
            left: 'auto',
            top: 'auto',
            right: 2,
            bottom: 2,
            backgroundColor: `${palette.white}d4`,
            borderRadius: '50%',
            marginRight: 20,
            marginBottom: 8,
            height: 32,
            width: 32,
            padding: 0,

            '&:before': {
              content: '"\\E711"',
            },

            '&:hover': {
              '&:before': {
                color: palette.white,
              },
            },
          },
        },

        '& .image-list-item .image-list-item-image.with-new-editor-icon': {
          '&:hover': {
            '& .image-list-item-action-bar': {
              opacity: 1,
            },
          },
          '& .image-list-item-action-bar': {
            '&.open': {
              opacity: 1,
            },
            opacity: 0,
            position: 'absolute',
            bottom: '6px',
            gap: '6px',
            translate: '-50%',
            left: '50%',
            display: 'flex',
            '& button.image-edit, button.image-delete': {
              border: 'none',
              boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.14), 0px 0px 2px 0px rgba(0, 0, 0, 0.12)',
            },
            '& button.is-recommended-image': {
              opacity: 0.5,
            },
          },
        },

        '& .image-list-item .image-list-item-image.with-copilot-option': {
          '&:hover': {
            '& .image-list-item-action-bar': {
              opacity: 1,
            },
          },
          '& .image-list-item-action-bar': {
            '&.open': {
              opacity: 1,
            },
            display: 'flex',
            backgroundColor: palette.white,
            borderRadius: 8,
            opacity: 0,
            position: 'absolute',
            bottom: 6,
            marginLeft: 6,
            padding: [0, 8, 0, 4],
            overflow: 'hidden',

            '& button': {
              minWidth: 24,
              margin: [6, 0, 6, 4],
              width: 24,
              height: 24,
              padding: 0,
              border: 'none',
              backgroundColor: palette.white,
              '& img': {
                width: 24,
                height: 24,
              },
              '& .active': {
                display: 'none',
                backgroundColor: palette.themeDarkAlt,
              },
              '& .passive': {
                display: 'inline-block',
                backgroundColor: palette.white,
              },
              '&:hover, &:focus': {
                '& .active': {
                  display: 'inline-block',
                },
                '& .passive': {
                  display: 'none',
                },
              },
            },
            '& .action-divider': {
              margin: [6, 0, 6, 4],
              width: 1,
              height: 24,
              display: 'inline-block',
              borderLeft: `1px solid ${palette.neutralQuaternaryAlt}`,
            },
            '& .glyphicon.glyphicon-remove.image-delete': {
              position: 'static',
              margin: [6, 0, 6, 4],
              width: 24,
              height: 24,
              extend: floatButtonStyle({ palette }).floatButton,
              fontSize: 16,
              color: palette.neutralPrimary,
              backgroundColor: palette.white,
              padding: 0,
              borderRadius: 'unset',
              opacity: 1,

              '&:before': {
                content: '"\\E74D"',
              },
              '&:hover': {
                backgroundColor: palette.themeDarkAlt,
                '&:before': {
                  color: palette.white,
                },
              },
            },
          },

          '& .glyphicon.glyphicon-pencil.image-edit': {
            position: 'static',
            margin: [6, 0, 6, 4],
            width: 24,
            height: 24,
            borderRadius: 'unset',
            backgroundColor: palette.white,
            '&:before': {
              color: palette.neutralPrimary,
            },
            '&:hover': {
              '&:before': {
                color: palette.white,
              },
              backgroundColor: palette.themeDarkAlt,
            },
            opacity: 1,
          },
        },

        '& .image-list-add-placeholder': {
          position: 'relative',
          top: -6,
          width: 116,
          height: 99,
          background: 'transparent',
          borderStyle: 'dashed',
          borderColor: '#c8c6c4',
          borderRadius: 6,
          borderWidth: 1,
        },

        '& .remove-all-button': {
          visibility: 'hidden',
        },

        '& .image-list-choice-group': {
          '& .ms-Label, & .ms-ChoiceField-labelWrapper': {
            display: 'none',
          },

          '& .ms-ChoiceFieldGroup-flexContainer': {
            display: 'flex',
            flexFlow: 'row',
            flexWrap: 'wrap',
            width: '490px',

            '& .ms-ChoiceField': {
              marginRight: 8,
              background: 'transparent',

              '& .ms-ChoiceField-field': {
                borderWidth: 2,
                height: 99,
                width: 112,
                padding: 0,
                borderRadius: 6,

                '&:before, &:after': {
                  zIndex: 1,
                },
              },

              '& .ms-ChoiceField-innerField': {
                padding: 0,
                height: 99,
                width: 112,
              },
            },
          },
        },
      },
    },
  },
});

export const getStyles = (components, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '@global': {
    ...extensionEditorStyles({ palette }),
  },
  imageExperienceContainer: {
    ...imageExperienceContentStyle(palette, iconFontFamily),
    ...pmaxImageExperienceContentStyle(palette, iconFontFamily),
    ...editImageCommonStyle(palette, iconFontFamily),
  },
  imageListLoadingContainer: {
    minHeight: 84,
    '& .loading': {
      paddingTop: 30,
    },
  },
  imageListErrorContainer: {
    paddingTop: 10,
    '& .alert': {
      alignItems: 'center',
      padding: [4, 16, 4, 12],

      '& .alert-image:before': {
        lineHeight: '32px',
      },

      '& .alert__content': {
        display: 'flex',
        flexDirection: 'row',
        flexGrow: 1,
        alignItems: 'center',
      },

      '& .alert__action': {
        marginLeft: 'auto',
        marginTop: 'unset',
      },
    },
  },
  ariaAnnounce: {
    display: 'block',
    opacity: 0,
    height: 2,
    width: 2,
    margin: -1,
  },
});

export const getAdPreviewStyles = (components, { palette = {} }) => ({
  adPreviewContainer: {
    '& .new-preview-carousel-container-adprelib': {
      border: 0,
      boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)',
      borderRadius: '2px',
      backgroundColor: `${palette.white}`,
    },
    '& .ad-preview-controls-container': {
      paddingBottom: 10,
    },
    '& .ad-preview-actions': {
      '& button': {
        marginRight: 8,
      },
    },
    '& .ad-preview-title': {
      '& .preview-title-string-key': {
        fontSize: 14,
        fontWeight: 'bold',
        marginRight: 8,
      },
      '& .preview-title-preview-type': {
        fontSize: 14,
      },
    },
    '& .preview-type-string': {
      visibility: 'hidden',
    },
    '& .carousel-wrapper': {
      '& .carousel-inner': {
        height: 515,
        merginTop: 10,
      },
      '& .carousel-control': {
        background: 'transparent',
      },
    },
  },

  carouselLayoutClassName: {
    border: 0,
    boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)',
    borderRadius: '2px',
    backgroundColor: `${palette.white}`,

    '& .carousel-wrapper': {
      '& .carousel-inner': {
        height: 515,
      },
      '& .carousel-control.left, .carousel-control.right': {
        left: 0,
        bottom: -7,
        background: 'transparent',
        zIndex: 20,
      },
    },
  },
  carouselControlsMsn: {
    '& .carousel-wrapper': {
      '& .carousel-control.left': {
        marginLeft: 200,
      },
      '& .carousel-control.right': {
        marginLeft: 430,
      },
      '& .carousel-indicators': {
        marginLeft: 240,
        margin: '20px 24px',
        left: 0,
      },
    },
  },
  carouselControlsOthers: {
    '& .carousel-wrapper': {
      '& .carousel-control.left': {
        marginLeft: 270,
      },
      '& .carousel-control.right': {
        marginLeft: 357,
      },
      '& .carousel-indicators': {
        marginLeft: 310,
        margin: '20px 24px',
        left: 0,
      },
    },
  },
  customCarouselRoot: {
    '& .custom-carousel-controls-and-indicators': {
      transform: 'translateX(-15px) translateX(-50%)',
      left: '50%',

      '& .carousel-control.left': {
        marginRight: '10px !important',
      },
      '& .carousel-control.right': {
        marginLeft: '5px !important',
      },
    },
  },
  adExtensionContainer: {
    // todo: add styles for ad extension preview components if needed
    margin: 10,
  },
  placementContainerClassName: {
    minWidth: 669,
    border: '0 !important',
    boxShadow: 'unset !important',
    borderRadius: '0 !important',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',

    '& .placement-validation-message': {
      display: 'inline-block',
      width: '100%',
      fontSize: 14,
      textAlign: 'center',
      lineHeight: 2,
      marginRight: 16,
    },
  },
  carouselLayoutHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',

    '& .carousel-header-texts': {
      display: 'inline-block',
      margin: '20px 8px 16px 24px',
      fontSize: 18,
      lineHeight: '24px',

      '& .carousel-header-ratio': {
        fontSize: 14,
        fontWeight: 'bold',
        marginRight: 8,
      },
      '& .carousel-header-title': {
        fontSize: 14,
      },
    },
    '& .ad-preview-actions': {
      display: 'flex',
      flexDirection: 'row',
      flexGrow: 0,
      flexShrink: 0,
      alignItems: 'center',
      marginRight: 16,
      '& button': {
        marginRight: 8,
      },
    },
  },
});

const geCarouselStyleForMsan = {
  root: {
    '& .carousel-wrapper': {
      '& .carousel-control.left': {
        marginLeft: 200,
      },
      '& .carousel-control.right': {
        marginLeft: 430,
      },
    },
  },
  previewCarousel: {
    bottomCarouselNavigation: {
      '& .carousel-indicators': {
        marginLeft: 240,
        margin: '20px 24px',
        left: 0,
      },
    },
  },
};

const geCarouselStyleForOthers = {
  root: {
    '& .carousel-wrapper': {
      '& .carousel-control.left': {
        marginLeft: 270,
      },
      '& .carousel-control.right': {
        marginLeft: 357,
      },
    },
  },
  previewCarousel: {
    bottomCarouselNavigation: {
      '& .carousel-indicators': {
        marginLeft: 310,
        margin: '20px 24px',
        left: 0,
      },
    },
  },
};

export const getCarouselControlsAndIndicatorsStyleBySurface = (surface) => {
  switch (surface) {
    case 'Bing':
    case 'Edge':
    case 'Outlook':
      return geCarouselStyleForOthers;
    case 'Msn':
    default:
      return geCarouselStyleForMsan;
  }
};

export const getSummaryCardStyles = () => ({
  ImageListCardDetailsContainer: {
    '& img': {
      borderRadius: 6,
      filter: 'drop-shadow(0px 0.6px 1.8px rgba(0, 0, 0, 0.1)) drop-shadow(0px 3.2px 7.2px rgba(0, 0, 0, 0.13))',
      maxHeight: 48,
      marginRight: 10,
      marginTop: 5,
    },
  },
});

export const getImageSuggestionCarouselStyles = (_components, { palette } = {}) => ({
  ImageSuggestionCarouselContainer: {
    '& .image-suggestion-carousel-root': {
      '& .collapsible-title > a': {
        fontSize: 12,
        fontWeight: 600,
        '&:hover': {
          background: 'transparent',
        },
      },
    },
  },
  InfoMessageBar: {
    background: palette.themeLighterAlt,
  },
});

export const getImageSuggestionPanelStyles = () => ({
  panel: {
    top: 60,
  },
  panelHeader: {
    paddingLeft: 32,
    paddingRight: 24,
    alignSelf: 'justify-start',
    flexGrow: 1,
  },
  panelTitle: {
    fontSize: 20,
    fontWeight: 600,
    display: 'inline-block',
    lineHeight: '27px',
    paddingBottom: 20,
  },
  backButton: {
    display: 'inline-block',
    paddingRight: 10,
  },
  theme: {
    marginBottom: 14,
    marginLeft: 4,
  },
  buttonContainer: {
    alignItems: 'center',
  },
  errorMessage: {
    marginTop: 16,
  },
});

export const imageSuggestionPanelWidth = '920px';
